import React from "react";

function OnionDisplay(props) {
  const image = require("../static/" + props.onion.image);
  const infoFields = Object.keys(props.onion);
  return (
    <div className="onionDisplay">
      <p className="onionDisplayTitle">{props.onion.Name}</p>
      <img src={image} alt={props.onion.Name} className="onionImage" />

      {infoFields.map((k) => {
        return (
          // TODO: Figure out how to exclude certain elements (id, image)
          <p>
            <b>{k}:</b> {props.onion[k]}
          </p>
        );
      })}
    </div>
  );
}

class OnionPage extends React.Component {
  constructor(props) {
    super(props);
    const onion = props.onions["alexeshoo"];
    this.state = { onion: onion };
  }

  renderOnionButton(m) {
    return (
      <button
        key={m}
        className="onionPicker"
        onClick={() => {
          this.pickOnion(m);
        }}
      >
        {m}
      </button>
    );
  }

  pickOnion(m) {
    const onion = this.props.onions[m];
    this.setState({ onion: onion });
  }

  render() {
    return (
      <div>
        <div>
          {this.renderOnionButton("alexeshoo")}
          {this.renderOnionButton("dennisdunne")}
        </div>
        <OnionDisplay onion={this.state.onion} />
      </div>
    );
  }
}

export default OnionPage;
